enum I18nLocaleEnum {
  en = 'en',
  ar = 'ar',
}

export default I18nLocaleEnum;
